import React, { useEffect } from "react";
import toTop from "../images/toTop.svg";
import "./toTopButton.css";

const ToTopButton = () => {
  window.addEventListener("scroll", () => {
    const btn = document.querySelector(".to_top_button");

    if (window.pageYOffset > 560) {
      if (btn) {
        btn.classList.add("active");
      }
    } else {
      if (btn) {
        btn.classList.remove("active");
      }
    }
  });

  return (
    <a href="#" className="to_top_button">
      <img src={toTop} alt="button" />
    </a>
  );
};

export default ToTopButton;
